// Auto-generated by scripts/generate-exports.mjs — do not edit manually.
// Source: countries/cr/current/*.pem

export const BANCO_CENTRAL_DE_COSTA_RICA_AGENTE_ELECTRONICO = `-----BEGIN CERTIFICATE-----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-----END CERTIFICATE-----`

export const CA_POLITICA_PERSONA_FISICA_COSTA_RICA_V2 = `-----BEGIN CERTIFICATE-----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-----END CERTIFICATE-----`

export const CA_POLITICA_PERSONA_JURIDICA_COSTA_RICA_V2 = `-----BEGIN CERTIFICATE-----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-----END CERTIFICATE-----`

export const CA_RAIZ_NACIONAL_COSTA_RICA_V2 = `-----BEGIN CERTIFICATE-----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-----END CERTIFICATE-----`

export const CA_SINPE_PERSONA_FISICA_V2_2023 = `-----BEGIN CERTIFICATE-----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=
-----END CERTIFICATE-----`

export const CA_SINPE_PERSONA_FISICA_V2 = `-----BEGIN CERTIFICATE-----
MIINJzCCCw+gAwIBAgITSwAAAAXb/gO1NXUawwAAAAAABTANBgkqhkiG9w0BAQ0F
ADB9MRkwFwYDVQQFExBDUEotMi0xMDAtMDk4MzExMQswCQYDVQQGEwJDUjEPMA0G
A1UEChMGTUlDSVRUMQ0wCwYDVQQLEwREQ0ZEMTMwMQYDVQQDEypDQSBQT0xJVElD
QSBQRVJTT05BIEZJU0lDQSAtIENPU1RBIFJJQ0EgdjIwHhcNMTkxMjIwMjE1NDAx
WhcNMjcxMjIwMjIwNDAxWjCBmTEZMBcGA1UEBRMQQ1BKLTQtMDAwLTAwNDAxNzEL
MAkGA1UEBhMCQ1IxJDAiBgNVBAoTG0JBTkNPIENFTlRSQUwgREUgQ09TVEEgUklD
QTEiMCAGA1UECxMZRElWSVNJT04gU0lTVEVNQVMgREUgUEFHTzElMCMGA1UEAxMc
Q0EgU0lOUEUgLSBQRVJTT05BIEZJU0lDQSB2MjCCASIwDQYJKoZIhvcNAQEBBQAD
ggEPADCCAQoCggEBAPs79a3v0DTxTENn/EiPxLtGHjLTEaACg7j8gIQpw2ayZmLB
pXmxIHF83NPw2Lhf72t6WqZlVog/FQzT6c13PupFuEKpgrd/3Kz+InUVCyzn2Prf
Ek72DDpSTs25SEgNEBe8tNBflhnWDUfJdYBmHxbiz+ax9ogui3IoZ38MkhIruPni
2KxEuc93OMGCLqSg9Fh91l6NAvFPCd44bKrWt9WTn1mDpgkYMqLXvSJfmrUc39t+
mYBYvmzzvhaDGiGa44c1v3UEMtLCkCZxr4JX15p6nHHrro1Ht4rYbjZE+UgsvfU3
iIruGsOrOmyAPTd8ESwGnmR8cVUtjvuJAzAgB2UCAwEAAaOCCIEwggh9MBIGCSsG
AQQBgjcVAQQFAgMBAAEwIwYJKwYBBAGCNxUCBBYEFOY7fUWsDL4+b/VRuCuH6tVn
KOHWMB0GA1UdDgQWBBRfBRhBEN4VLzrpwBaj56FqUtE67DCCBdYGA1UdIASCBc0w
ggXJMIIBFAYHYIE8AQEBATCCAQcwgaYGCCsGAQUFBwICMIGZHoGWAEkAbQBwAGwA
ZQBtAGUAbgB0AGEAIABsAGEAIABQAG8AbABpAHQAaQBjAGEAIABkAGUAIABsAGEA
IABSAGEAaQB6ACAAQwBvAHMAdABhAHIAcgBpAGMAZQBuAHMAZQAgAGQAZQAgAEMA
ZQByAHQAaQBmAGkAYwBhAGMAaQBvAG4AIABEAGkAZwBpAHQAYQBsACAAdgAyMCoG
CCsGAQUFBwIBFh5odHRwOi8vd3d3LmZpcm1hZGlnaXRhbC5nby5jcgAwMAYIKwYB
BQUHAgEWJGh0dHA6Ly93d3cubWljaXQuZ28uY3IvZmlybWFkaWdpdGFsADCCAVUG
CGCBPAEBAQEBMIIBRzCB5gYIKwYBBQUHAgIwgdkegdYASQBtAHAAbABlAG0AZQBu
AHQAYQAgAGwAYQAgAFAAbwBsAGkAdABpAGMAYQAgAGQAZQAgAEMAQQAgAEUAbQBp
AHMAbwByAGEAIABwAGEAcgBhACAAUABlAHIAcwBvAG4AYQBzACAARgBpAHMAaQBj
AGEAcwAgAHAAZQByAHQAZQBuAGUAYwBpAGUAbgB0AGUAIABhACAAbABhACAAUABL
AEkAIABOAGEAYwBpAG8AbgBhAGwAIABkAGUAIABDAG8AcwB0AGEAIABSAGkAYwBh
ACAAdgAyMCoGCCsGAQUFBwIBFh5odHRwOi8vd3d3LmZpcm1hZGlnaXRhbC5nby5j
cgAwMAYIKwYBBQUHAgEWJGh0dHA6Ly93d3cubWljaXQuZ28uY3IvZmlybWFkaWdp
dGFsADCCAagGCGCBPAEBAQECMIIBmjCCATgGCCsGAQUFBwICMIIBKh6CASYASQBt
AHAAbABlAG0AZQBuAHQAYQAgAGwAYQAgAFAAbwBsAGkAdABpAGMAYQAgAHAAYQBy
AGEAIABjAGUAcgB0AGkAZgBpAGMAYQBkAG8AIABkAGUAIABmAGkAcgBtAGEAIABk
AGkAZwBpAHQAYQBsACAAZABlACAAcABlAHIAcwBvAG4AYQBzACAAZgBpAHMAaQBj
AGEAcwAgACgAYwBpAHUAZABhAGQAYQBuAG8ALwByAGUAcwBpAGQAZQBuAHQAZQAp
ACAAcABlAHIAdABlAG4AZQBjAGkAZQBuAHQAZQAgAGEAIABsAGEAIABQAEsASQAg
AE4AYQBjAGkAbwBuAGEAbAAgAGQAZQAgAEMAbwBzAHQAYQAgAFIAaQBjAGEAIAB2
ADIwKgYIKwYBBQUHAgEWHmh0dHA6Ly93d3cuZmlybWFkaWdpdGFsLmdvLmNyADAw
BggrBgEFBQcCARYkaHR0cDovL3d3dy5taWNpdC5nby5jci9maXJtYWRpZ2l0YWwA
MIIBqAYIYIE8AQEBAQMwggGaMIIBOAYIKwYBBQUHAgIwggEqHoIBJgBJAG0AcABs
AGUAbQBlAG4AdABhACAAbABhACAAUABvAGwAaQB0AGkAYwBhACAAcABhAHIAYQAg
AGMAZQByAHQAaQBmAGkAYwBhAGQAbwAgAGQAZQAgAGEAdQB0AGUAbgB0AGkAYwBh
AGMAaQBvAG4AIABkAGUAIABwAGUAcgBzAG8AbgBhAHMAIABmAGkAcwBpAGMAYQBz
ACAAKABjAGkAdQBkAGEAZABhAG4AbwAvAHIAZQBzAGkAZABlAG4AdABlACkAIABw
AGUAcgB0AGUAbgBlAGMAaQBlAG4AdABlACAAYQAgAGwAYQAgAFAASwBJACAATgBh
AGMAaQBvAG4AYQBsACAAZABlACAAQwBvAHMAdABhACAAUgBpAGMAYQAgAHYAMjAq
BggrBgEFBQcCARYeaHR0cDovL3d3dy5maXJtYWRpZ2l0YWwuZ28uY3IAMDAGCCsG
AQUFBwIBFiRodHRwOi8vd3d3Lm1pY2l0LmdvLmNyL2Zpcm1hZGlnaXRhbAAwGQYJ
KwYBBAGCNxQCBAweCgBTAHUAYgBDAEEwCwYDVR0PBAQDAgGGMBIGA1UdEwEB/wQI
MAYBAf8CAQAwHwYDVR0jBBgwFoAUaJ1pNsuEbnvqk2EZ/1gwHdX/XMswgeoGA1Ud
HwSB4jCB3zCB3KCB2aCB1oZmaHR0cDovL3d3dy5maXJtYWRpZ2l0YWwuZ28uY3Iv
cmVwb3NpdG9yaW8vQ0ElMjBQT0xJVElDQSUyMFBFUlNPTkElMjBGSVNJQ0ElMjAt
JTIwQ09TVEElMjBSSUNBJTIwdjIuY3JshmxodHRwOi8vd3d3Lm1pY2l0LmdvLmNy
L2Zpcm1hZGlnaXRhbC9yZXBvc2l0b3Jpby9DQSUyMFBPTElUSUNBJTIwUEVSU09O
QSUyMEZJU0lDQSUyMC0lMjBDT1NUQSUyMFJJQ0ElMjB2Mi5jcmwwgf4GCCsGAQUF
BwEBBIHxMIHuMHIGCCsGAQUFBzAChmZodHRwOi8vd3d3LmZpcm1hZGlnaXRhbC5n
by5jci9yZXBvc2l0b3Jpby9DQSUyMFBPTElUSUNBJTIwUEVSU09OQSUyMEZJU0lD
QSUyMC0lMjBDT1NUQSUyMFJJQ0ElMjB2Mi5jcnQweAYIKwYBBQUHMAKGbGh0dHA6
Ly93d3cubWljaXQuZ28uY3IvZmlybWFkaWdpdGFsL3JlcG9zaXRvcmlvL0NBJTIw
UE9MSVRJQ0ElMjBQRVJTT05BJTIwRklTSUNBJTIwLSUyMENPU1RBJTIwUklDQSUy
MHYyLmNydDANBgkqhkiG9w0BAQ0FAAOCAgEAT3K7mmQqxoC5unYq2HAmupjYoVBo
teb52nCmG5c9LLuUiCuLTFIrd18m1zcYwx8Jc/e4bAJ52U9G1U0QGT/jq66JTlMX
oEQjN/fs1J5uri5mKAourLjUyp/ieiCHAOgk1oQW1gV7YauqJDHkNM4mXdSW7aym
QyZ8UgekILH5fgX9bCEP/uxfxyAxVnBABb+WEsjSnNHnRkwW2PjiSJ93+9xtj5OX
fux+GqqtmArmpsUYw/tZClOQjt6YLuiokNpK+ZOyTTcyDSZ9LMnW90Lgsmp8Bkq5
pRwmtzX+UPRxLjaRiOQMXbC8a4UQYtz6G/8PPrPDivg/Nj6qVAIawdbVwiVCkFbH
gGFFhgyS3R2gLK6Dsa4m6vDzdRhkB7GmnVr0x4wNT8xmpuc/edVVSZlK76Kt/DVt
8DGR8tZlK1ZVU4b1v84UWcbVyEhtcfCI1V/a9GQzEL0IAi2OwNmWiQwMIBVl59FP
qyUNXT1k2B0GMu6Z7VHnNwGvurvZ75pcv2oj22xnGQmY0l+kMXmBS7LCeBZ4Rrqa
b0bvbD+9wmno3rFDBpOGsFG1ue6E4uzKCGwheroOtznjEU53/Q5mjBtar9fn5a2i
9QvPMHxuiNt1Ey9wRgrHukRd5e2ZWYWZbebOXc+qmQoou0VAwhW7+/RClDSRmOZ6
2nh9q2UEeh0rIi8=
-----END CERTIFICATE-----`

export const CA_SINPE_PERSONA_JURIDICA_V2 = `-----BEGIN CERTIFICATE-----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-----END CERTIFICATE-----`

/** All certificates for this country, in alphabetical order. */
export const ALL_CERTS = [
  { name: 'BANCO CENTRAL DE COSTA RICA (AGENTE ELECTRONICO)', exportName: 'BANCO_CENTRAL_DE_COSTA_RICA_AGENTE_ELECTRONICO', pem: BANCO_CENTRAL_DE_COSTA_RICA_AGENTE_ELECTRONICO },
  { name: 'CA POLITICA PERSONA FISICA - COSTA RICA v2', exportName: 'CA_POLITICA_PERSONA_FISICA_COSTA_RICA_V2', pem: CA_POLITICA_PERSONA_FISICA_COSTA_RICA_V2 },
  { name: 'CA POLITICA PERSONA JURIDICA - COSTA RICA v2', exportName: 'CA_POLITICA_PERSONA_JURIDICA_COSTA_RICA_V2', pem: CA_POLITICA_PERSONA_JURIDICA_COSTA_RICA_V2 },
  { name: 'CA RAIZ NACIONAL - COSTA RICA v2', exportName: 'CA_RAIZ_NACIONAL_COSTA_RICA_V2', pem: CA_RAIZ_NACIONAL_COSTA_RICA_V2 },
  { name: 'CA SINPE - PERSONA FISICA v2 (2023)', exportName: 'CA_SINPE_PERSONA_FISICA_V2_2023', pem: CA_SINPE_PERSONA_FISICA_V2_2023 },
  { name: 'CA SINPE - PERSONA FISICA v2', exportName: 'CA_SINPE_PERSONA_FISICA_V2', pem: CA_SINPE_PERSONA_FISICA_V2 },
  { name: 'CA SINPE - PERSONA JURIDICA v2', exportName: 'CA_SINPE_PERSONA_JURIDICA_V2', pem: CA_SINPE_PERSONA_JURIDICA_V2 }
]
